import React from 'react'

export const ACCESSIBE_TRIGGER_ID = 'accessibeTrigger'

/**
 * Click handler for anything that should open the accessiBe panel. Forwards the
 * click to the hidden trigger below, which is the element accessiBe is actually
 * bound to.
 *
 * @param {object} e - The click event
 * @returns {void}
 */
export const openAccessibilityControls = e => {
  e.preventDefault()
  document.getElementById(ACCESSIBE_TRIGGER_ID)?.click()
}

/**
 * The element accessiBe binds its panel to. Its SDK looks for
 * `data-acsb-custom-trigger` when it loads, so the trigger has to be in the DOM
 * by then — which rules out the account menu's "Accessibility controls" item:
 * the desktop dropdown only mounts its items while the menu is open, and the
 * mobile account menu is a page that mounts on navigation. Both call
 * openAccessibilityControls instead, which clicks this.
 *
 * Render once near the root of the app so it outlives every menu.
 *
 * @returns {JSX} A visually hidden button
 */
export const AccessibeTrigger = () => (
  <button
    id={ACCESSIBE_TRIGGER_ID}
    type="button"
    aria-hidden
    tabIndex={-1}
    className="sr-only"
    data-acsb-custom-trigger="true"
  />
)
